// extracted by mini-css-extract-plugin
export default {"container":"tabs_container__OKjn1","tabContainer":"tabs_tabContainer__+It9d","tabActive":"tabs_tabActive__BQ5zm"};